module.exports = {"Enterprise16":{"daobanList":[{"title":"1:是否设立非学历教育机构","values":[{"name":"是","xuanzhong":1,"cailiaoList":[{"name":"1、广东省非学历教育机构申报审批表","state":"必要"},{"name":"非学科类校外培训机构设立申请材料","state":"必要"}]},{"name":"否","xuanzhong":0,"cailiaoList":[]}]}]}}


//////////////////
// WEBPACK FOOTER
// ./static/js/situation/sde-16.json
// module id = 1247
// module chunks = 0